import type { StripeError } from '@stripe/stripe-js';
import BookingError from './BookingError';

export default function getNormalisedError(error: Error | StripeError | string, message?: string) {
  if (typeof error === 'string') {
    return new BookingError(error);
  }

  // Stripe error
  if ('type' in error) {
    const stripeError = new Error(`${error.type} - ${message}`, {
      cause: error,
    });
    stripeError.name = 'WebStripeError';

    return stripeError;
  }

  // Errors with a distinct name (StripeError, WebStripeError, AuthError, AbortError, ...) keep their own New Relic grouping; only otherwise-generic errors become BookingError.
  if (error.name === 'Error') {
    return new BookingError(error.message, { cause: error });
  }

  return error;
}
